// Language utility for file metadata
export interface Language {
    code: string;
    label: string;
    nativeLabel: string;
    labelFr: string;
}

export const LANGUAGES: Language[] = [
    { code: "aa", label: "Afar", nativeLabel: "Afaraf", labelFr: "Afar" },
    { code: "ab", label: "Abkhazian", nativeLabel: "Аҧсуа", labelFr: "Abkhaze" },
    { code: "ae", label: "Avestan", nativeLabel: "Avesta", labelFr: "Avestique" },
    { code: "af", label: "Afrikaans", nativeLabel: "Afrikaans", labelFr: "Afrikaans" },
    { code: "ak", label: "Akan", nativeLabel: "Akan", labelFr: "Akan" },
    { code: "am", label: "Amharic", nativeLabel: "አማርኛ", labelFr: "Amharique" },
    { code: "an", label: "Aragonese", nativeLabel: "Aragonés", labelFr: "Aragonais" },
    { code: "ar", label: "Arabic", nativeLabel: "العربية", labelFr: "Arabe" },
    { code: "as", label: "Assamese", nativeLabel: "অসমীয়া", labelFr: "Assamais" },
    { code: "av", label: "Avaric", nativeLabel: "авар мацӀ", labelFr: "Avar" },
    { code: "ay", label: "Aymara", nativeLabel: "Aymar aru", labelFr: "Aymara" },
    { code: "az", label: "Azerbaijani", nativeLabel: "Azərbaycan dili", labelFr: "Azéri" },
    { code: "ba", label: "Bashkir", nativeLabel: "башҡорт теле", labelFr: "Bachkir" },
    { code: "be", label: "Belarusian", nativeLabel: "Беларуская", labelFr: "Biélorusse" },
    { code: "bg", label: "Bulgarian", nativeLabel: "български език", labelFr: "Bulgare" },
    { code: "bh", label: "Bihari", nativeLabel: "भोजपुरी", labelFr: "Bihari" },
    { code: "bi", label: "Bislama", nativeLabel: "Bislama", labelFr: "Bichelamar" },
    { code: "bm", label: "Bambara", nativeLabel: "Bamanankan", labelFr: "Bambara" },
    { code: "bn", label: "Bengali", nativeLabel: "বাংলা", labelFr: "Bengali" },
    { code: "bo", label: "Tibetan", nativeLabel: "བོད་ཡིག", labelFr: "Tibétain" },
    { code: "br", label: "Breton", nativeLabel: "Brezhoneg", labelFr: "Breton" },
    { code: "bs", label: "Bosnian", nativeLabel: "Bosanski jezik", labelFr: "Bosnien" },
    { code: "ca", label: "Catalan", nativeLabel: "Català", labelFr: "Catalan" },
    { code: "ce", label: "Chechen", nativeLabel: "нохчийн мотт", labelFr: "Tchétchène" },
    { code: "ch", label: "Chamorro", nativeLabel: "Chamoru", labelFr: "Chamorro" },
    { code: "co", label: "Corsican", nativeLabel: "Corsu", labelFr: "Corse" },
    { code: "cr", label: "Cree", nativeLabel: "ᓀᐦᐃᔭᐍᐏᐣ", labelFr: "Cri" },
    { code: "cs", label: "Czech", nativeLabel: "Česky", labelFr: "Tchèque" },
    { code: "cu", label: "Old Church Slavonic", nativeLabel: "Словѣньскъ", labelFr: "Vieux-slave" },
    { code: "cv", label: "Chuvash", nativeLabel: "чӑваш чӗлхи", labelFr: "Tchouvache" },
    { code: "cy", label: "Welsh", nativeLabel: "Cymraeg", labelFr: "Gallois" },
    { code: "da", label: "Danish", nativeLabel: "Dansk", labelFr: "Danois" },
    { code: "de", label: "German", nativeLabel: "Deutsch", labelFr: "Allemand" },
    { code: "dv", label: "Divehi", nativeLabel: "ދިވެހި", labelFr: "Maldivien" },
    { code: "dz", label: "Dzongkha", nativeLabel: "རྫོང་ཁ", labelFr: "Dzongkha" },
    { code: "ee", label: "Ewe", nativeLabel: "Ɛʋɛgbɛ", labelFr: "Ewe" },
    { code: "el", label: "Greek", nativeLabel: "Ελληνικά", labelFr: "Grec moderne" },
    { code: "en", label: "English", nativeLabel: "English", labelFr: "Anglais" },
    { code: "eo", label: "Esperanto", nativeLabel: "Esperanto", labelFr: "Espéranto" },
    { code: "es", label: "Spanish", nativeLabel: "Español", labelFr: "Espagnol" },
    { code: "et", label: "Estonian", nativeLabel: "Eesti keel", labelFr: "Estonien" },
    { code: "eu", label: "Basque", nativeLabel: "Euskara", labelFr: "Basque" },
    { code: "fa", label: "Persian", nativeLabel: "فارسی", labelFr: "Persan" },
    { code: "ff", label: "Fulah", nativeLabel: "Fulfulde", labelFr: "Peul" },
    { code: "fi", label: "Finnish", nativeLabel: "Suomen kieli", labelFr: "Finnois" },
    { code: "fj", label: "Fijian", nativeLabel: "Vosa Vakaviti", labelFr: "Fidjien" },
    { code: "fo", label: "Faroese", nativeLabel: "Føroyskt", labelFr: "Féroïen" },
    { code: "fr", label: "French", nativeLabel: "Français", labelFr: "Français" },
    { code: "fy", label: "Western Frisian", nativeLabel: "Frysk", labelFr: "Frison occidental" },
    { code: "ga", label: "Irish", nativeLabel: "Gaeilge", labelFr: "Irlandais" },
    { code: "gd", label: "Scottish Gaelic", nativeLabel: "Gàidhlig", labelFr: "Écossais" },
    { code: "gl", label: "Galician", nativeLabel: "Galego", labelFr: "Galicien" },
    { code: "gn", label: "Guarani", nativeLabel: "Avañe", labelFr: "Guarani" },
    { code: "gu", label: "Gujarati", nativeLabel: "ગુજરાતી", labelFr: "Gujarati" },
    { code: "gv", label: "Manx", nativeLabel: "Ghaelg", labelFr: "Mannois" },
    { code: "ha", label: "Hausa", nativeLabel: "هَوُسَ", labelFr: "Haoussa" },
    { code: "he", label: "Hebrew", nativeLabel: "עברית", labelFr: "Hébreu" },
    { code: "hi", label: "Hindi", nativeLabel: "हिन्दी", labelFr: "Hindi" },
    { code: "ho", label: "Hiri Motu", nativeLabel: "Hiri Motu", labelFr: "Hiri motu" },
    { code: "hr", label: "Croatian", nativeLabel: "Hrvatski", labelFr: "Croate" },
    { code: "ht", label: "Haitian", nativeLabel: "Kreyòl ayisyen", labelFr: "Créole haïtien" },
    { code: "hu", label: "Hungarian", nativeLabel: "magyar", labelFr: "Hongrois" },
    { code: "hy", label: "Armenian", nativeLabel: "Հայերեն", labelFr: "Arménien" },
    { code: "hz", label: "Herero", nativeLabel: "Otjiherero", labelFr: "Héréro" },
    { code: "ia", label: "Interlingua", nativeLabel: "Interlingua", labelFr: "Interlingua" },
    { code: "id", label: "Indonesian", nativeLabel: "Bahasa Indonesia", labelFr: "Indonésien" },
    { code: "ie", label: "Interlingue", nativeLabel: "Interlingue", labelFr: "Occidental" },
    { code: "ig", label: "Igbo", nativeLabel: "Igbo", labelFr: "Igbo" },
    { code: "ii", label: "Sichuan Yi", nativeLabel: "ꆇꉙ", labelFr: "Yi" },
    { code: "ik", label: "Inupiaq", nativeLabel: "Iñupiaq", labelFr: "Inupiak" },
    { code: "io", label: "Ido", nativeLabel: "Ido", labelFr: "Ido" },
    { code: "is", label: "Icelandic", nativeLabel: "Íslenska", labelFr: "Islandais" },
    { code: "it", label: "Italian", nativeLabel: "Italiano", labelFr: "Italien" },
    { code: "iu", label: "Inuktitut", nativeLabel: "ᐃᓄᒃᑎᑐᑦ", labelFr: "Inuktitut" },
    { code: "ja", label: "Japanese", nativeLabel: "日本語", labelFr: "Japonais" },
    { code: "jv", label: "Javanese", nativeLabel: "Basa Jawa", labelFr: "Javanais" },
    { code: "ka", label: "Georgian", nativeLabel: "ქართული", labelFr: "Géorgien" },
    { code: "kg", label: "Kongo", nativeLabel: "KiKongo", labelFr: "Kikongo" },
    { code: "ki", label: "Kikuyu", nativeLabel: "Gĩkũyũ", labelFr: "Kikuyu" },
    { code: "kj", label: "Kwanyama", nativeLabel: "Kuanyama", labelFr: "Kuanyama" },
    { code: "kk", label: "Kazakh", nativeLabel: "Қазақ тілі", labelFr: "Kazakh" },
    { code: "kl", label: "Greenlandic", nativeLabel: "Kalaallisut", labelFr: "Groenlandais" },
    { code: "km", label: "Khmer", nativeLabel: "ភាសាខ្មែរ", labelFr: "Khmer" },
    { code: "kn", label: "Kannada", nativeLabel: "ಕನ್ನಡ", labelFr: "Kannada" },
    { code: "ko", label: "Korean", nativeLabel: "한국어", labelFr: "Coréen" },
    { code: "kr", label: "Kanuri", nativeLabel: "Kanuri", labelFr: "Kanouri" },
    { code: "ks", label: "Kashmiri", nativeLabel: "कश्मीरी", labelFr: "Cachemiri" },
    { code: "ku", label: "Kurdish", nativeLabel: "Kurdî", labelFr: "Kurde" },
    { code: "kv", label: "Komi", nativeLabel: "коми кыв", labelFr: "Komi" },
    { code: "kw", label: "Cornish", nativeLabel: "Kernewek", labelFr: "Cornique" },
    { code: "ky", label: "Kirghiz", nativeLabel: "кыргыз тили", labelFr: "Kirghiz" },
    { code: "la", label: "Latin", nativeLabel: "Latine", labelFr: "Latin" },
    { code: "lb", label: "Luxembourgish", nativeLabel: "Lëtzebuergesch", labelFr: "Luxembourgeois" },
    { code: "lg", label: "Ganda", nativeLabel: "Luganda", labelFr: "Ganda" },
    { code: "li", label: "Limburgish", nativeLabel: "Limburgs", labelFr: "Limbourgeois" },
    { code: "ln", label: "Lingala", nativeLabel: "Lingála", labelFr: "Lingala" },
    { code: "lo", label: "Lao", nativeLabel: "ພາສາລາວ", labelFr: "Lao" },
    { code: "lt", label: "Lithuanian", nativeLabel: "Lietuvių kalba", labelFr: "Lituanien" },
    { code: "lu", label: "Luba", nativeLabel: "tshiluba", labelFr: "Luba" },
    { code: "lv", label: "Latvian", nativeLabel: "Latviešu valoda", labelFr: "Letton" },
    { code: "mg", label: "Malagasy", nativeLabel: "Fiteny malagasy", labelFr: "Malgache" },
    { code: "mh", label: "Marshallese", nativeLabel: "Kajin M̧ajeļ", labelFr: "Marshallais" },
    { code: "mi", label: "Māori", nativeLabel: "Te reo Māori", labelFr: "Maori de Nouvelle-Zélande" },
    { code: "mk", label: "Macedonian", nativeLabel: "македонски јазик", labelFr: "Macédonien" },
    { code: "ml", label: "Malayalam", nativeLabel: "മലയാളം", labelFr: "Malayalam" },
    { code: "mn", label: "Mongolian", nativeLabel: "Монгол", labelFr: "Mongol" },
    { code: "mo", label: "Moldavian", nativeLabel: "лимба молдовеняскэ", labelFr: "Moldave" },
    { code: "mr", label: "Marathi", nativeLabel: "मराठी", labelFr: "Marathi" },
    { code: "ms", label: "Malay", nativeLabel: "Bahasa Melayu", labelFr: "Malais" },
    { code: "mt", label: "Maltese", nativeLabel: "Malti", labelFr: "Maltais" },
    { code: "my", label: "Burmese", nativeLabel: "ဗမာစာ", labelFr: "Birman" },
    { code: "na", label: "Nauru", nativeLabel: "Ekakairũ Naoero", labelFr: "Nauruan" },
    { code: "nb", label: "Norwegian Bokmål", nativeLabel: "Norsk bokmål", labelFr: "Norvégien bokmål" },
    { code: "nd", label: "North Ndebele", nativeLabel: "isiNdebele", labelFr: "Sindebele" },
    { code: "ne", label: "Nepali", nativeLabel: "नेपाली", labelFr: "Népalais" },
    { code: "ng", label: "Ndonga", nativeLabel: "Owambo", labelFr: "Ndonga" },
    { code: "nl", label: "Dutch", nativeLabel: "Nederlands", labelFr: "Néerlandais" },
    { code: "nn", label: "Norwegian Nynorsk", nativeLabel: "Norsk nynorsk", labelFr: "Norvégien nynorsk" },
    { code: "no", label: "Norwegian", nativeLabel: "Norsk", labelFr: "Norvégien" },
    { code: "nr", label: "South Ndebele", nativeLabel: "Ndébélé", labelFr: "Nrebele" },
    { code: "nv", label: "Navajo", nativeLabel: "Diné bizaad", labelFr: "Navajo" },
    { code: "ny", label: "Chichewa", nativeLabel: "ChiCheŵa", labelFr: "Chichewa" },
    { code: "oc", label: "Occitan", nativeLabel: "Occitan", labelFr: "Occitan" },
    { code: "oj", label: "Ojibwa", nativeLabel: "ᐊᓂᔑᓈᐯᒧᐎᓐ", labelFr: "Ojibwé" },
    { code: "om", label: "Oromo", nativeLabel: "Afaan Oromoo", labelFr: "Oromo" },
    { code: "or", label: "Oriya", nativeLabel: "ଓଡ଼ିଆ", labelFr: "Oriya" },
    { code: "os", label: "Ossetian", nativeLabel: "Ирон ӕвзаг", labelFr: "Ossète" },
    { code: "pa", label: "Panjabi", nativeLabel: "ਪੰਜਾਬੀ", labelFr: "Pendjabi" },
    { code: "pi", label: "Pāli", nativeLabel: "पािऴ", labelFr: "Pali" },
    { code: "pl", label: "Polish", nativeLabel: "Polski", labelFr: "Polonais" },
    { code: "ps", label: "Pashto", nativeLabel: "پښتو", labelFr: "Pachto" },
    { code: "pt", label: "Portuguese", nativeLabel: "Português", labelFr: "Portugais" },
    { code: "qu", label: "Quechua", nativeLabel: "Runa Simi", labelFr: "Quechua" },
    { code: "rm", label: "Romansh", nativeLabel: "Rumantsch grischun", labelFr: "Romanche" },
    { code: "rn", label: "Kirundi", nativeLabel: "kiRundi", labelFr: "Kirundi" },
    { code: "ro", label: "Romanian", nativeLabel: "Română", labelFr: "Roumain" },
    { code: "ru", label: "Russian", nativeLabel: "русский язык", labelFr: "Russe" },
    { code: "rw", label: "Kinyarwanda", nativeLabel: "Kinyarwanda", labelFr: "Kinyarwanda" },
    { code: "sa", label: "Sanskrit", nativeLabel: "संस्कृतम्", labelFr: "Sanskrit" },
    { code: "sc", label: "Sardinian", nativeLabel: "sardu", labelFr: "Sarde" },
    { code: "sd", label: "Sindhi", nativeLabel: "सिन्धी", labelFr: "Sindhi" },
    { code: "se", label: "Northern Sami", nativeLabel: "Davvisámegiella", labelFr: "Same du Nord" },
    { code: "sg", label: "Sango", nativeLabel: "Yângâ tî sängö", labelFr: "Sango" },
    { code: "sh", label: "Serbo-Croatian", nativeLabel: "српскохрватски језик", labelFr: "Serbo-croate" },
    { code: "si", label: "Sinhalese", nativeLabel: "සිංහල", labelFr: "Cingalais" },
    { code: "sk", label: "Slovak", nativeLabel: "Slovenčina", labelFr: "Slovaque" },
    { code: "sl", label: "Slovenian", nativeLabel: "Slovenščina", labelFr: "Slovène" },
    { code: "sm", label: "Samoan", nativeLabel: "Gagana fa'a Samoa", labelFr: "Samoan" },
    { code: "sn", label: "Shona", nativeLabel: "chiShona", labelFr: "Shona" },
    { code: "so", label: "Somali", nativeLabel: "Soomaaliga", labelFr: "Somali" },
    { code: "sq", label: "Albanian", nativeLabel: "Shqip", labelFr: "Albanais" },
    { code: "sr", label: "Serbian", nativeLabel: "српски језик", labelFr: "Serbe" },
    { code: "ss", label: "Swati", nativeLabel: "SiSwati", labelFr: "Swati" },
    { code: "st", label: "Sotho", nativeLabel: "seSotho", labelFr: "Sotho du Sud" },
    { code: "su", label: "Sundanese", nativeLabel: "Basa Sunda", labelFr: "Soundanais" },
    { code: "sv", label: "Swedish", nativeLabel: "Svenska", labelFr: "Suédois" },
    { code: "sw", label: "Swahili", nativeLabel: "Kiswahili", labelFr: "Swahili" },
    { code: "ta", label: "Tamil", nativeLabel: "தமிழ்", labelFr: "Tamoul" },
    { code: "te", label: "Telugu", nativeLabel: "తెలుగు", labelFr: "Télougou" },
    { code: "tg", label: "Tajik", nativeLabel: "тоҷикӣ", labelFr: "Tadjik" },
    { code: "th", label: "Thai", nativeLabel: "ไทย", labelFr: "Thaï" },
    { code: "ti", label: "Tigrinya", nativeLabel: "ትግርኛ", labelFr: "Tigrigna" },
    { code: "tk", label: "Turkmen", nativeLabel: "Türkmen", labelFr: "Turkmène" },
    { code: "tl", label: "Tagalog", nativeLabel: "Tagalog", labelFr: "Tagalog" },
    { code: "tn", label: "Tswana", nativeLabel: "seTswana", labelFr: "Tswana" },
    { code: "to", label: "Tonga", nativeLabel: "faka Tonga", labelFr: "Tongien" },
    { code: "tr", label: "Turkish", nativeLabel: "Türkçe", labelFr: "Turc" },
    { code: "ts", label: "Tsonga", nativeLabel: "xiTsonga", labelFr: "Tsonga" },
    { code: "tt", label: "Tatar", nativeLabel: "татарча", labelFr: "Tatar" },
    { code: "tw", label: "Twi", nativeLabel: "Twi", labelFr: "Twi" },
    { code: "ty", label: "Tahitian", nativeLabel: "Reo Mā'ohi", labelFr: "Tahitien" },
    { code: "ug", label: "Uighur", nativeLabel: "ئۇيغۇرچ", labelFr: "Ouïghour" },
    { code: "uk", label: "Ukrainian", nativeLabel: "українська мова", labelFr: "Ukrainien" },
    { code: "ur", label: "Urdu", nativeLabel: "اردو", labelFr: "Ourdou" },
    { code: "uz", label: "Uzbek", nativeLabel: "O'zbek", labelFr: "Ouzbek" },
    { code: "ve", label: "Venda", nativeLabel: "tshiVenḓa", labelFr: "Venda" },
    { code: "vi", label: "Vietnamese", nativeLabel: "Tiếng Việt", labelFr: "Vietnamien" },
    { code: "vo", label: "Volapük", nativeLabel: "Volapük", labelFr: "Volapük" },
    { code: "wa", label: "Walloon", nativeLabel: "Walon", labelFr: "Wallon" },
    { code: "wo", label: "Wolof", nativeLabel: "Wollof", labelFr: "Wolof" },
    { code: "xh", label: "Xhosa", nativeLabel: "isiXhosa", labelFr: "Xhosa" },
    { code: "yi", label: "Yiddish", nativeLabel: "ייִדיש", labelFr: "Yiddish" },
    { code: "yo", label: "Yoruba", nativeLabel: "Yorùbá", labelFr: "Yoruba" },
    { code: "za", label: "Zhuang", nativeLabel: "Saɯ cueŋƅ", labelFr: "Zhuang" },
    { code: "zh", label: "Chinese", nativeLabel: "中文", labelFr: "Chinois" },
    { code: "zu", label: "Zulu", nativeLabel: "isiZulu", labelFr: "Zoulou" },
];

// Get language by code
export const getLanguageByCode = (code: string): Language | undefined => {
    return LANGUAGES.find((lang) => lang.code === code);
};

// Get language label by code
export const getLanguageLabel = (code: string): string => {
    const language = getLanguageByCode(code);
    return language ? language.label : code;
};

// Get native language label by code
export const getNativeLanguageLabel = (code: string): string => {
    const language = getLanguageByCode(code);
    return language ? language.nativeLabel : code;
};

// Get French language label by code
export const getFrenchLanguageLabel = (code: string): string => {
    const language = getLanguageByCode(code);
    return language ? language.labelFr : code;
};
